import styled from 'styled-components';
import { Colors } from '../../utils/figmaColors';
import { HORIZONTAL_PADDING } from '../../components/layout/constants';

export const OuterContainer = styled.section`
  background-color: ${Colors.lightBackground};
  width: 100%;
  padding: 120px 0;
  position: relative;
  overflow: hidden;
  
  @media (max-width: 768px) {
    padding: 80px 0;
  }
`;

export const PatternDecoration = styled.div`
  position: absolute;
  left: 28px;
  top: 261px;
  width: 305.8px;
  height: 275px;
  opacity: 0.1;
  pointer-events: none;
  
  @media (max-width: 1200px) {
    display: none;
  }
`;

export const ContentContainer = styled.div`
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
  padding: 0 ${HORIZONTAL_PADDING};
  display: flex;
  flex-direction: column;
  gap: 80px;
  box-sizing: border-box;
  min-width: 0;
  
  @media (max-width: 1200px) {
    gap: 60px;
    align-items: center;
  }
  
  @media (max-width: 768px) {
    gap: 40px;
  }
`;

export const MissionHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 80px;
  width: 100%;
  min-width: 0;
  
  @media (max-width: 1200px) {
    align-items: center;
    gap: 48px;
  }
  
  @media (max-width: 768px) {
    gap: 40px;
  }
`;

export const MissionTitle = styled.h2`
  font-family: 'Mulish', sans-serif;
  font-size: clamp(40px, 5vw, 80px);
  font-weight: 600;
  line-height: 1.25;
  color: ${Colors.darkText};
  margin: 0;
  letter-spacing: -0.02em;
  width: 100%;
  text-align: center;
  
  @media (max-width: 768px) {
    font-size: clamp(32px, 8vw, 48px);
  }
`;

export const MissionContent = styled.div`
  display: flex;
  align-items: flex-start;
  gap: clamp(54px, 12vw + 24px, 174px);
  width: 100%;
  min-width: 0;
  
  @media (max-width: 1200px) {
    flex-direction: column;
    align-items: center;
    gap: 40px;
  }
`;

export const MissionText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1 1 0;
  min-width: 0;
  max-width: 513px;
  
  @media (max-width: 1200px) {
    max-width: 100%;
    align-items: center;
    text-align: center;
  }
`;

export const MissionSubtitle = styled.h3`
  font-family: 'Mulish', sans-serif;
  font-size: clamp(24px, 3vw, 45px);
  font-weight: 600;
  line-height: 1.25;
  color: ${Colors.darkText};
  margin: 0;
  letter-spacing: -0.02em;
  
  @media (min-width: 1200px) {
    white-space: nowrap;
  }
`;

export const MissionDescription = styled.p`
  font-family: 'Mulish', sans-serif;
  font-size: clamp(16px, 2vw, 24px);
  font-weight: 400;
  line-height: 1.5;
  color: ${Colors.mediumText};
  margin: 0;
  max-width: 468px;
  
  @media (max-width: 1200px) {
    max-width: 100%;
  }
`;

export const CounterBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(16px, 2.6vw, 47px) clamp(24px, 3.3vw, 47px);
  background-color: ${Colors.darkSectionBg};
  border: 2.97px solid ${Colors.buttonBg};
  border-radius: 93.46px;
  box-shadow: 0px 5.93px 41.54px rgba(0, 0, 0, 0.11);
  box-sizing: border-box;
  flex: 0 1 auto;
  min-width: 0;
  width: min(560px, calc(42vw - 40px));
  max-width: 100%;
  
  @media (max-width: 1200px) {
    width: 100%;
    max-width: min(600px, 90vw);
    padding: clamp(16px, 2.5vw, 40px) clamp(24px, 3.5vw, 40px);
  }
  
  @media (max-width: 768px) {
    padding: 16px 24px;
    border-radius: 60px;
  }
`;

export const CounterContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  text-align: center;
`;

export const CounterNumber = styled.div`
  font-family: 'Mulish', sans-serif;
  font-size: clamp(40px, 4.5vw, 74px);
  font-weight: 600;
  line-height: 1;
  color: ${Colors.white};
  letter-spacing: -0.02em;
`;

export const CounterLabel = styled.div`
  font-family: 'Mulish', sans-serif;
  font-size: clamp(12px, 1.4vw, 20px);
  font-weight: 400;
  line-height: 1.2;
  color: ${Colors.white};
`;

export const CTAButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 13px 36px;
  background-color: ${Colors.buttonBg};
  color: ${Colors.darkText};
  border: none;
  border-radius: 100px;
  font-family: 'Mulish', sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 30px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.3s ease;
  align-self: center;
  margin-top: 20px;
  
  &:hover {
    transform: translateY(-2px);
  }
  
  @media (max-width: 768px) {
    padding: 11.5px 20px;
    font-size: 16px;
    gap: 8px;
  }
`;
